module.exports = "<span cian-ui-tooltip-template=\"'agent-bonus-tooltip.html'\"\n      class=\"agent-bonus-tooltip-el\"\n      tooltip-class=\"cui-tooltip-default\"\n      tooltip-placement=\"bottom-left\"\n      tooltip-trigger=\"mouseenter\">\n    <ng-transclude></ng-transclude>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/agent-bonus/agent-bonus-tooltip.html
// module id = 518
// module chunks = 0